
import React from 'react';
import CardDeck from 'react-bootstrap/CardDeck';
import Col from 'react-bootstrap/Col';
import ArticleCard from './article-card'; 
import AddArticleCard from './article-add'; 
import { MetaArticle } from './page_data';

import { updateArticleHandler } from '../globals';

type ArticlesGridProps = {
  editMode: boolean,
  articles: Array<MetaArticle>,
  btnClickHandler: (articleId: string) => void,
  addBtnClickHandler: () => void,
  deleteBtnHandler: (id: string) => void,
};

const ArticleGridView: React.FunctionComponent<ArticlesGridProps> = ({
    editMode,
    articles,
    btnClickHandler,
    addBtnClickHandler,
    deleteBtnHandler,
}) => (
  <Col>
    <div className="article-heading text-center">
      <h1>
        <span className="text-uppercase">Featured </span>
        Topics
      </h1>
    </div>
    <div>
      <CardDeck className="d-flex">
        {editMode
           ? <AddArticleCard
               btnClickHandler={addBtnClickHandler}
             />
           : ''
        }
        {articles.length > 0
          ? articles.map(({
              id,
              href,
              title,
              imageSrc
            }: MetaArticle, i): React.ReactNode => (
              <ArticleCard 
                key={i}
                id={id}
                href={href}
                title={title}
                imageSrc={imageSrc}
                btnClickHandler={()=>btnClickHandler(id)}
                deleteBtnHandler={deleteBtnHandler}
                editMode={editMode}
              />
            ))
          : <div className="empty-search mx-auto text-centered">
              No Topics Match Your Search Conditions'
            </div>
        }
      </CardDeck>
    </div>
  </Col>
);

export default ArticleGridView;
